<template>
  <div>
    <!-- -------------------------Evaluaciones para corregir Profesor------------------------- -->
    <Card
      v-if="user && user.group_names.includes('PROFESORES')"
      class="dashboard-card"
      :hide_title="hide_title"
    >
      <template v-slot:title>
        <b-icon class="card-header-icon" icon="file-earmark-check"></b-icon>
        {{
          $t("dashboard.dashboardView.toCorrect", {
            entity: $getVisibleNames(
              "evaluations2.evaluation",
              true,
              "Evaluaciones"
            ),
          })
        }}
      </template>
      <template v-slot:content>
        <template v-if="institution && institution.kl_assessment">
          <div
            v-if="
              !allEvaluationsPublished &&
              (instrument_correction.length != 0 ||
                optionsMatterCorrectTest.length > 1 ||
                optionsCareerCorrectTest.length > 1 ||
                optionsSectionCorrectTest.length > 1 ||
                optionsCampuCorrectTest.length > 1)
            "
            class="container-select mb-2 noprint"
          >
            <div>
              <b-form-select
                id="input-campus"
                class="select-form"
                v-model="select_campus_correct_test"
                :options="optionsCampuCorrectTest"
                @change="getInstrumentCorrection()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-career"
                class="select-form"
                v-model="select_career_correct_test"
                :options="optionsCareerCorrectTest"
                @change="getInstrumentCorrection()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-matter"
                class="select-form"
                v-model="select_matter_correct_test"
                :options="optionsMatterCorrectTest"
                @change="getInstrumentCorrection()"
              ></b-form-select>
            </div>
            <div>
              <b-form-select
                id="input-section"
                class="select-form"
                v-model="select_section_correct_test"
                :options="optionsSectionCorrectTest"
                @change="getInstrumentCorrection()"
              ></b-form-select>
            </div>
          </div>
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              instrument_correction.length > 0 &&
              !allEvaluationsPublished
            "
          >
            <b-table-simple
              borderless
              small
              hover
              sticky-header="400px"
              class="border-table"
            >
              <b-thead>
                <b-tr>
                  <!-- Columna Nombre Evaluacion (Evaluacion)-->
                  <b-th class="primary-cell-correction-test cell-wide">
                    {{
                      $getVisibleNames(
                        "evaluations2.evaluation",
                        false,
                        "Evaluación"
                      )
                    }}
                  </b-th>
                  <b-th class="primary-cell-correction-test cell-wide">{{
                    $getVisibleNames("evaluations2.test", false, "Instrumento")
                  }}</b-th>
                  <b-th class="primary-cell-correction-test cell-nowrap">
                    {{ $t("dashboard.dashboardView.type") }}
                  </b-th>
                  <b-th class="primary-cell-correction-test cell-nowrap">
                    {{ $getVisibleNames("mesh.campus", false, "Sede") }}
                  </b-th>
                  <b-th class="primary-cell-correction-test">
                    {{ $getVisibleNames("mesh.career", false, "Programa") }}
                  </b-th>
                  <b-th class="primary-cell-correction-test cell-wide">{{
                    $getVisibleNames(
                      "mesh.egressprofilematter",
                      false,
                      "Asignatura"
                    )
                  }}</b-th>
                  <b-th class="primary-cell-correction-test cell-nowrap">{{
                    $getVisibleNames("teaching.section", false, "Sección")
                  }}</b-th>
                  <b-th class="primary-cell-correction-test cell-nowrap">{{
                    $t("reusable.common.startDate")
                  }}</b-th>
                  <b-th class="primary-cell-correction-test cell-nowrap">{{
                    $t("reusable.common.endDate")
                  }}</b-th>
                  <b-th class="primary-cell-correction-test text-center">{{
                    $t("dashboard.dashboardView.state")
                  }}</b-th>
                </b-tr>
              </b-thead>

              <b-tbody>
                <!-- instrument_correction -->
                <template v-for="test in sortedEvaluations">
                  <b-tr :key="test.id">
                    <!-- Nombre de la Evaluacion (Evaluacion) -->
                    <b-td class="secondary-cell-correction-test text-left">
                      <div class="mr-0">
                        {{ test.evaluation_title }}
                      </div>
                    </b-td>
                    <!-- Nombre de la Evaluacion (Test) -->
                    <b-td class="secondary-cell-correction-test text-left">
                      <span
                        class="div-href-test"
                        v-b-tooltip.v-secondary.top.noninteractive="{
                          title: $t('dashboard.dashboardView.goToCorrect', {
                            entity: $getVisibleNames(
                              'evaluations2.evaluation',
                              false,
                              'Evaluación'
                            ),
                          }),
                          boundary: 'viewport',
                        }"
                        @click="
                          redirectToInstrumentCorrection(
                            test.evaluation_id,
                            test.id
                          )
                        "
                      >
                        {{ test.title }}
                      </span>
                    </b-td>
                    <!-- Tipo de la Evaluacion (Evaluacion) -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-nowrap"
                    >
                      <div
                        class="mr-0"
                        v-b-tooltip.v-secondary.top.noninteractive="{
                          title: $t('dashboard.dashboardView.entityOfEntity', {
                            entity1: test.evaluative_agent_name,
                            entity2: $getVisibleNames(
                              'evaluations2.test',
                              false,
                              'Instrumento'
                            ),
                          }),
                          boundary: 'viewport',
                        }"
                      >
                        {{ test.evaluation_type_default }}
                      </div>
                    </b-td>
                    <!-- Sede -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-nowrap"
                    >
                      {{ test.campus }}
                    </b-td>
                    <!-- Carrera -->
                    <b-td class="secondary-cell-correction-test text-left">
                      {{ test.career_name }}
                    </b-td>
                    <!-- Asignatura -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-wide"
                    >
                      {{ test.matter_code }} - {{ test.matter_name }}
                    </b-td>
                    <!-- Seccion -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-nowrap"
                    >
                      {{ test.section_name }}
                    </b-td>
                    <!-- Fecha de Inicio -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-nowrap"
                      :class="{
                        'text-blue': isDateInProgress(
                          test.start_time,
                          test.end_time
                        ),
                      }"
                      v-b-tooltip.v-secondary.top.noninteractive="{
                        title: isDateInProgress(test.start_time, test.end_time)
                          ? $t('dashboard.dashboardView.inProgress', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                false,
                                'Evaluación'
                              ),
                            })
                          : '',
                        boundary: 'viewport',
                      }"
                    >
                      <template v-if="test.start_time">
                        {{ test.start_time | FormatToDateTime }}
                      </template>
                      <template v-else>
                        {{ $t("reusable.common.notApplicable") }}
                      </template>
                    </b-td>
                    <!-- Fecha de Termino -->
                    <b-td
                      class="secondary-cell-correction-test text-left cell-nowrap"
                      :class="{
                        'text-blue': isDateInProgress(
                          test.start_time,
                          test.end_time
                        ),
                      }"
                      v-b-tooltip.v-secondary.top.noninteractive="{
                        title: isDateInProgress(test.start_time, test.end_time)
                          ? $t('dashboard.dashboardView.inProgress', {
                              entity: $getVisibleNames(
                                'evaluations2.evaluation',
                                false,
                                'Evaluación'
                              ),
                            })
                          : '',
                        boundary: 'viewport',
                      }"
                    >
                      <template v-if="test.end_time">
                        {{ test.end_time | FormatToDateTime }}
                      </template>
                      <template v-else>
                        {{ $t("reusable.common.notApplicable") }}
                      </template>
                    </b-td>
                    <!-- Evaluados que faltan por evaluar -->
                    <b-td class="secondary-cell-correction-test text-center">
                      <template v-if="test">
                        <div class="state-grid">
                          <div class="state-row">
                            <span
                              class="state-item"
                              v-b-tooltip.v-secondary.top.noninteractive="{
                                title: $t(
                                  'dashboard.dashboardView.studentsNotStarted',
                                  {
                                    entity: $getVisibleNames(
                                      'evaluations2.evaluation',
                                      false,
                                      'Evaluación'
                                    ),
                                  }
                                ),
                                boundary: 'viewport',
                              }"
                            >
                              <!-- Estudiantes que No comenzaron el test -->
                              ❌
                              <span>
                                {{
                                  test.total_evaluatees -
                                  test.started_evaluatees
                                }}
                              </span>
                            </span>
                            <span
                              class="state-item"
                              v-b-tooltip.v-secondary.top.noninteractive="{
                                title: isDateAfterTest(test.end_time)
                                  ? $t(
                                      'dashboard.dashboardView.studentsStartedNotFinished',
                                      {
                                        entity: $getVisibleNames(
                                          'evaluations2.evaluation',
                                          false,
                                          'Evaluación'
                                        ),
                                      }
                                    )
                                  : $t(
                                      'dashboard.dashboardView.studentsDoing',
                                      {
                                        entity: $getVisibleNames(
                                          'evaluations2.evaluation',
                                          false,
                                          'Evaluación'
                                        ),
                                      }
                                    ),
                                boundary: 'viewport',
                              }"
                            >
                              <!-- Estudiantes que comenzaron el test -->
                              <template v-if="!isDateAfterTest(test.end_time)">
                                🟡
                              </template>
                              <!-- Estudiantes que comenzaron el test pero no lo finalizaron cuando terminó "end_time" -->
                              <template v-else> 🟠 </template>
                              <span>
                                {{
                                  test.started_evaluatees -
                                  test.finished_evaluatees
                                }}
                              </span>
                            </span>
                            <span
                              class="state-item"
                              v-b-tooltip.v-secondary.top.noninteractive="{
                                title: $t(
                                  'dashboard.dashboardView.studentsFinished',
                                  {
                                    entity: $getVisibleNames(
                                      'evaluations2.evaluation',
                                      false,
                                      'Evaluación'
                                    ),
                                  }
                                ),
                                boundary: 'viewport',
                              }"
                            >
                              <!-- Estudiantes que terminaron el test -->
                              🟢
                              <span>
                                {{ test.finished_evaluatees }}
                              </span>
                            </span>
                          </div>
                          <div class="state-row">
                            <span
                              class="state-item"
                              v-b-tooltip.v-secondary.top.noninteractive="{
                                title: $t(
                                  'dashboard.dashboardView.studentsPublishedGrade'
                                ),
                                boundary: 'viewport',
                              }"
                            >
                              <!-- Estudiantes que ya se le publicó la nota/puntaje -->
                              📝
                              <span>
                                {{ test.published_evaluatees }}
                              </span>
                            </span>
                            <span
                              class="state-item"
                              v-b-tooltip.v-secondary.top.noninteractive="{
                                title: $t(
                                  'dashboard.dashboardView.totalStudents'
                                ),
                                boundary: 'viewport',
                              }"
                            >
                              <!-- Total de Estudiantes -->
                              👥
                              <span>
                                {{ test.total_evaluatees }}
                              </span>
                            </span>
                          </div>
                        </div>
                      </template>
                      <template v-else>
                        {{ $t("reusable.common.notApplicable") }}
                      </template>
                    </b-td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </template>
          <template
            v-if="
              user.group_names.includes('PROFESORES') && allEvaluationsPublished
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.allEvaluationsCorrected", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    true,
                    "Evaluaciones"
                  ),
                })
              }}
            </div>
          </template>
          <template
            v-if="
              user.group_names.includes('PROFESORES') &&
              instrument_correction.length == 0
            "
          >
            <div class="text-left">
              {{
                $t("dashboard.dashboardView.noEntityToCorrect", {
                  entity: $getVisibleNames(
                    "evaluations2.evaluation",
                    true,
                    "Evaluaciones"
                  ),
                })
              }}
            </div>
          </template>
        </template>
        <template v-else>
          <div class="text-left">
            <span>{{ $t("dashboard.dashboardView.moduleNotEnabled") }}</span>
          </div>
        </template>
      </template>
    </Card>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "InstrumentCorrection",
  components: {
    Card: () => import("@/components/users/Card"),
  },
  props: {
    hide_title: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      first_fetch_correct_test: true,
      select_matter_correct_test: null,
      select_career_correct_test: null,
      select_section_correct_test: null,
      select_campus_correct_test: null,
      instrument_correction: [],
      optionsMatterCorrectTest: [],
      optionsCareerCorrectTest: [],
      optionsSectionCorrectTest: [],
      optionsCampuCorrectTest: [],
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
    }),
    sortedEvaluations() {
      return this.instrument_correction
        .filter((x) => x.all_published == false)
        .sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
    },
    allEvaluationsPublished() {
      return (
        this.instrument_correction.length > 0 &&
        this.instrument_correction.every((test) => test.all_published == true)
      );
    },
  },
  methods: {
    isDateInProgress(start_time, end_time) {
      const now = new this.$moment();
      const startDate = this.$moment(start_time);
      const endDate = this.$moment(end_time);

      return startDate.isSameOrBefore(now) && endDate.isSameOrAfter(now);
      // estamos verificando si la fecha actual (now) está dentro del rango de tiempo
    },
    isDateAfterTest(end_time) {
      const now = new this.$moment();
      const endDateTest = this.$moment(end_time);

      return now.isAfter(endDateTest);
    },
    optionsMattersCorrectTest(mattersFromApi) {
      this.optionsMatterCorrectTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames(
              "mesh.egressprofilematter",
              false,
              "Asignatura"
            ),
          }),
        },
      ];
      // Crear un Map para almacenar carreras únicas
      const uniqueMatters = new Map();
      // Iterar sobre los datos de la API y llenar el Map
      mattersFromApi.forEach((x) => {
        if (!uniqueMatters.has(x.matter_name)) {
          uniqueMatters.set(x.matter_name, x.matter_id);
        }
      });
      // Convertir el Map en un array de opciones y añadirlo a optionsMatterCorrectTest
      uniqueMatters.forEach((id, name) => {
        this.optionsMatterCorrectTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCareersCorrectTest(careersFromApi) {
      this.optionsCareerCorrectTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.career", false, "Programa"),
          }),
        },
      ];
      const uniqueCareers = new Map();
      careersFromApi.forEach((x) => {
        if (!uniqueCareers.has(x.career_name)) {
          uniqueCareers.set(x.career_name, x.career_id);
        }
      });
      uniqueCareers.forEach((id, name) => {
        this.optionsCareerCorrectTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsSectionsCorrectTest(sectionsFromApi) {
      this.optionsSectionCorrectTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("teaching.section", false, "Sección"),
          }),
        },
      ];
      const uniqueSections = new Map();
      sectionsFromApi.forEach((x) => {
        if (!uniqueSections.has(x.section_name)) {
          uniqueSections.set(x.section_name, x.section_id);
        }
      });
      uniqueSections.forEach((id, name) => {
        this.optionsSectionCorrectTest.push({
          value: id,
          text: name,
        });
      });
    },
    optionsCampusCorrectTest(campusFromApi) {
      this.optionsCampuCorrectTest = [
        {
          value: null,
          text: this.$t("dashboard.dashboardView.filterBy", {
            entity: this.$getVisibleNames("mesh.campus", false, "Sede"),
          }),
        },
      ];
      const uniqueCampus = new Map();
      campusFromApi.forEach((x) => {
        if (!uniqueCampus.has(x.campus)) {
          uniqueCampus.set(x.campus, x.campus_id);
        }
      });
      uniqueCampus.forEach((id, name) => {
        this.optionsCampuCorrectTest.push({
          value: id,
          text: name,
        });
      });
    },
    redirectToInstrumentCorrection(evaluation_id, instrument_id = null) {
      this.$router.push({
        name: "EvaluatorView",
        params: {
          evaluation_id: evaluation_id,
          instrument_id: instrument_id,
        },
      });
    },
    getInstrumentCorrection() {
      if (
        this.user &&
        this.user.group_names.includes("PROFESORES") &&
        this.institution &&
        this.institution.kl_assessment
      ) {
        let arr = [];

        if (this.select_campus_correct_test != null)
          arr.push("campus=" + this.select_campus_correct_test);
        if (this.select_career_correct_test != null)
          arr.push("career=" + this.select_career_correct_test);
        if (this.select_matter_correct_test != null)
          arr.push("matter=" + this.select_matter_correct_test);
        if (this.select_section_correct_test != null)
          arr.push("section=" + this.select_section_correct_test);

        let partial_url = "";
        if (arr.length > 0) partial_url = "?" + arr.join("&");

        this.$restful
          .Get(`/evaluations2/dashboard_teacher_correct_tests/${partial_url}`)
          .then((response) => {
            this.instrument_correction = response;
            this.$emit(
              "count",
              response.filter((x) => x.all_published == false).length
            );
            if (this.first_fetch_correct_test) {
              this.optionsMattersCorrectTest(this.instrument_correction);
              this.optionsCareersCorrectTest(this.instrument_correction);
              this.optionsSectionsCorrectTest(this.instrument_correction);
              this.optionsCampusCorrectTest(this.instrument_correction);
              this.first_fetch_correct_test = false;
            }
          });
      }
    },
  },
  mounted() {
    this.getInstrumentCorrection();
  },
  watch: {
    user() {
      this.getInstrumentCorrection();
    },
    institution() {
      this.getInstrumentCorrection();
    },
  },
  created() {
    this.$hasPermissions();
  },
};
</script>

<style scoped>
.text-blue {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
}
.dashboard-card {
  display: block;
  margin: 0;
}
.dashboard-card >>> .card-container {
  background: var(--kl-surface);
  border: 1px solid var(--kl-border-soft);
  border-radius: var(--kl-card-radius);
  box-shadow: 0 2px 4px rgba(16, 38, 73, 0.06);
  overflow: hidden;
}
.dashboard-card >>> .card-body {
  background: var(--kl-surface) !important;
  padding: 16px;
}
.card-header-icon {
  margin-right: 0.35em;
}
.border-table {
  border-radius: var(--kl-radius-lg);
  border: 1px solid var(--kl-border);
  max-height: calc(100vh - 290px) !important;
  overflow-y: auto;
}
.border-table >>> table {
  margin-bottom: 0;
}
.border-table >>> tbody tr:nth-child(even) > td {
  background-color: var(--kl-surface-muted);
}
.border-table >>> tbody tr:hover > td {
  background-color: var(--kl-surface-hover);
}
.primary-cell-correction-test {
  text-align: left;
  vertical-align: middle;
  background: var(--kl-color-accent-soft) !important;
  color: var(--kl-color-primary) !important;
  font-weight: var(--kl-fw-bold);
  font-size: var(--kl-fs-caption);
  text-transform: uppercase;
  letter-spacing: var(--kl-ls-wide);
  padding: 11px 12px !important;
  border-bottom: none !important;
}
.secondary-cell-correction-test {
  text-align: center;
  vertical-align: middle;
  color: var(--kl-text-body);
  font-size: var(--kl-fs-body);
  padding: 11px 12px !important;
  border-bottom: 1px solid var(--kl-border-soft) !important;
}
/* Columnas de texto corto: nunca se parten (ej. "Sumativa", fechas, sección) */
.cell-nowrap {
  white-space: nowrap;
}
/* Columnas de texto largo: pueden partirse y absorben el ancho sobrante */
.cell-wide {
  min-width: 160px;
  white-space: normal;
  word-break: break-word;
}
.state-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.state-row {
  display: flex;
  justify-content: center;
  gap: 12px;
}
.state-item {
  white-space: nowrap;
  font-size: var(--kl-fs-small);
}
.div-href-test {
  color: var(--kl-color-primary);
  font-weight: var(--kl-fw-semibold);
  transition: color 0.2s ease;
}
.div-href-test:hover {
  color: var(--kl-color-primary-deep) !important;
  text-decoration: underline;
  cursor: pointer;
}
.container-select {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 14px;
}
.container-select > div {
  flex: 1 1 calc(25% - 10px);
  min-width: 200px;
}
.select-form {
  width: 100%;
  height: 40px;
  font-size: var(--kl-fs-body);
  color: var(--kl-text-heading);
  border: 1px solid var(--kl-border-soft) !important;
  border-radius: var(--kl-input-radius) !important;
  background-color: var(--kl-surface);
}
.select-form:focus {
  border-color: var(--kl-color-primary) !important;
  box-shadow: 0 0 0 3px rgba(0, 110, 200, 0.15) !important;
}
@media (max-width: 992px) {
  .container-select > div {
    flex: 1 1 calc(50% - 10px);
  }
}
@media (max-width: 576px) {
  .container-select > div {
    flex: 1 1 100%;
  }
}
@media print {
  .secondary-cell-correction-test {
    background-color: transparent !important;
  }
}
</style>